import { CSSProperties } from 'react';
import { decileMatrixStyles } from '../DecileMatrixStyles';
import { SeasonalMatrixVolatility } from './SeasonalMatrixTypes';

interface SeasonalMatrixVolatilityGaugeProps {
  volatility: SeasonalMatrixVolatility | null;
}

const scaleMarks = [100, 80, 60, 40, 20, 0];

const styles: Record<string, CSSProperties> = {
  container: { ...decileMatrixStyles.container, minWidth: '150px', alignItems: 'center' },
  index: { fontSize: '32px', fontWeight: 700, lineHeight: 1, margin: '0 0 8px 0', color: 'var(--font-color)' },
  gauge: { display: 'flex', gap: '8px', alignItems: 'stretch' },
  scale: { position: 'relative', width: '36px', margin: '22px 0' },
  scaleLabel: { position: 'absolute', right: 0, transform: 'translateY(50%)', fontSize: '12px', color: 'var(--font-color)' },
  barColumn: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' },
  endLabel: { fontSize: '12px', fontWeight: 700, lineHeight: '18px' },
  bar: {
    position: 'relative',
    width: '36px',
    height: '340px',
    borderRadius: '6px',
    background: 'linear-gradient(to top, var(--seasonal-matrix-volatility-low), var(--seasonal-matrix-volatility-medium), var(--seasonal-matrix-volatility-high))',
  },
  marker: { position: 'absolute', left: '-8px', right: '-8px', height: '4px', transform: 'translateY(50%)', background: 'var(--font-color)', borderRadius: '2px' },
};

export default function SeasonalMatrixVolatilityGauge({ volatility }: SeasonalMatrixVolatilityGaugeProps) {
  return (
    <div style={styles.container}>
      <h3 style={decileMatrixStyles.heading}>Volatility Index</h3>
      {volatility == null ? (
        <p style={{ textAlign: 'center', color: 'var(--font-color)' }}>Not enough price history to rank today.</p>
      ) : (
        <>
          <span style={styles.index}>{Math.round(volatility.index)}</span>
          <div style={styles.gauge}>
            <div style={styles.scale}>
              {scaleMarks.map((mark) => (
                <span key={mark} style={{ ...styles.scaleLabel, bottom: `${mark}%` }}>{mark}%</span>
              ))}
            </div>
            <div style={styles.barColumn}>
              <span style={{ ...styles.endLabel, color: 'var(--seasonal-matrix-volatility-high)' }}>HIGH</span>
              <div style={styles.bar}>
                <div style={{ ...styles.marker, bottom: `${volatility.index}%` }} />
              </div>
              <span style={{ ...styles.endLabel, color: 'var(--seasonal-matrix-volatility-low)' }}>LOW</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
